import React, { useEffect } from "react";
import { Book, MicrosoftExcelLogo } from "phosphor-react";
import styled from "styled-components";

// Context
import {
  ACTIONS,
  useExcelFileUploadContext,
} from "../../../context/ExcelFileUploadProvider";
import {
  useModalHistory,
  ACTIONS as MODAL_ACTIONS,
} from "../../../context/ModalHistoryProvider";

// Components
import { InputFile } from "../../Controls/InputFile";
import { UploadFileButton } from "../../Controls/UploadFileButton";
import Select from "../../Inputs/Select";
import StackStyle from "../../Styled/Stack.style";
import Modal from "../../Modal/Modal";
import MatchHeadersModal from "../../MatchHeaders/MatchHeadersModal";
import QueueStyle from "../../Styled/Queue.style";

// Utils
import {
  convertWorkSheetToJson,
  readFile,
} from "../../../utils/helpers/excelToJson";
import useType from "../../../utils/hooks/useType";
import colors from "../../../utils/constants/COLORS";
import { DEAL_TYPES } from "../../../utils/constants/SYSTEM";
import hasNoValue from "../../../utils/helpers/hasNoValue";

export default function SchemeDealsUploadModal() {
  const [{ excelWorkBook, excelSheet }, dispatch] = useExcelFileUploadContext();
  const [exceedLimitError, setExceedLimitError] = useType("boolean", false);
  const [, dispatchModalHistory] = useModalHistory();

  const pushEnd = (modal) =>
    dispatchModalHistory({
      type: MODAL_ACTIONS.PUSH_END,
      payload: { value: modal },
    });

  useEffect(() => {
    if (hasNoValue(excelSheet)) return;
    if (hasNoValue(excelWorkBook)) return;

    const workSheetCount = excelWorkBook?.SheetNames?.length;
    const workSheetRowsCount = Object.keys(
      excelWorkBook?.Sheets?.[excelSheet]
    ).length;

    if (workSheetCount >= 100000 || workSheetRowsCount >= 100000)
      setExceedLimitError(true);
    else setExceedLimitError(false);
  }, [excelWorkBook, excelSheet, setExceedLimitError]);

  // Clear workbook content
  useEffect(() => {
    return () => {
      dispatch({
        type: ACTIONS.SET_EXCEL_WORKBOOK,
        payload: { value: {} },
      })
    }
  }, [dispatch]);

  return (
    <Modal title="Please select a scheme deal excel file to upload">
      <StackStyle>
        <QueueStyle>
          <InputFile
            excelWorkBook={excelWorkBook}
            setExcelWorkSheetName={(value) => dispatch({ type: ACTIONS.SET_EXCEL_SHEET, payload: { value } })}
            setExceedLimitError={setExceedLimitError}
            readFile={readFile}
            dispatch={dispatch}
            suffix={
              <MicrosoftExcelLogo size={18} weight="fill" color="green" />
            }
          />
        </QueueStyle>
        <br />
        {Object.keys(excelWorkBook).length > 0 && (
          <Select
            defaultValue="Select sheet name"
            value={excelSheet}
            options={excelWorkBook.SheetNames}
            handleChange={(value) => dispatch({ type: ACTIONS.SET_EXCEL_SHEET, payload: { value } })}
            prefix={
              <Book
                size={18}
                weight="thin"
                color={colors.informational.color}
              />
            }
          />
        )}
        <br />
        {exceedLimitError && (
          <ErrorStyle>Exceeded row/sheet upload limit</ErrorStyle>
        )}
        <UploadFileButton
          onClick={() => {
            dispatch({
              type: ACTIONS.SET_EXCEL_JSON,
              payload: {
                value: convertWorkSheetToJson(
                  excelWorkBook.Sheets[excelSheet]
                ),
              },
            });

            pushEnd(<MatchHeadersModal scope={DEAL_TYPES.INSTALMENT_PRICE} />);
          }}
          disabled={!excelSheet || exceedLimitError}
        />
      </StackStyle>
    </Modal>
  );
}

const ErrorStyle = styled.span`
  color: red;
  font-weight: bold;
`;
